type LogLevel = 0 | 1 | 2 | 3;
type LogLevels = Record<string, LogLevel>;
export const Level: LogLevels = {
  OFF: 0,
  ERROR: 1,
  DELIVERY: 2,
  DEBUG: 3,
};

const reverseLevels = Object.keys(Level).reduce<{ [key: string]: string }>(
  (collector, k) => {
    const level = Level[k];
    collector[level] = k;
    return collector;
  },
  {}
);

const LOGGER_KEY = 'crm-message-bus-logger-level';
const LOGGER_TOPICS_KEY = 'crm-message-bus-logger-topics';

function isValidLogLevel(level: number): level is LogLevel {
  return Object.values(Level).includes(level as LogLevel);
}

let currentLevel: LogLevel | undefined;
let currentTopics: Array<string> | undefined;

function isLoggedTopic(topic: string) {
  const topics = getLoggedTopics();
  if (topics.length === 0) {
    return true;
  }
  return topics.includes(topic);
}

function getLoggingLevel(): LogLevel {
  if (currentLevel !== undefined) {
    return currentLevel;
  }

  currentLevel = 0;

  try {
    const levelStr = localStorage.getItem(LOGGER_KEY);
    if (levelStr) {
      const parsedLevel = parseInt(levelStr, 10);

      if (isValidLogLevel(parsedLevel)) {
        currentLevel = parsedLevel;
      }
    }
  } catch {
    currentLevel = 0;
  }
  return currentLevel;
}

function getLoggedTopics(): Array<string> {
  if (currentTopics !== undefined) {
    return currentTopics;
  }

  currentTopics = [];

  try {
    const topicsStr = localStorage.getItem(LOGGER_TOPICS_KEY);

    if (topicsStr) {
      currentTopics = topicsStr.split(',').map((t) => t.trim());
    }
  } catch {
    currentTopics = [];
  }
  return currentTopics;
}

function log(level: LogLevel, ...args: any[]) {
  const loggingLevel = getLoggingLevel();
  if (level && loggingLevel && level <= getLoggingLevel()) {
    args.unshift(`[CRM MessageBus ${reverseLevels[level]}]`);
    console.log(...args);
  }
}

function logTopic(level: LogLevel, topic: string, ...args: any[]) {
  const loggingLevel = getLoggingLevel();
  if (
    level &&
    loggingLevel &&
    level <= getLoggingLevel() &&
    isLoggedTopic(topic)
  ) {
    args.unshift(`[CRM MessageBus ${reverseLevels[level]}]`);
    console.log(...args);
  }
}

function setLevel(level: LogLevel | undefined) {
  if (
    level === undefined ||
    Object.keys(reverseLevels).includes(String(level))
  ) {
    currentLevel = level;
  }
}

export default { log, logTopic, setLevel };
